import { IBaseAction } from '../../../interfaces/IBaseAction'
export enum Keys {
    LOADTRAINERS = 'react/common/trainers/LOADTRAINERS',
    LOADTRAINERS_PENDING = 'react/common/trainers/LOADTRAINERS_PENDING',
    LOADTRAINERS_FULFILLED = 'react/common/trainers/LOADTRAINERS_FULFILLED',
    LOADTRAINERS_REJECTED = 'react/common/trainers/LOADTRAINERS_REJECTED',
    
    SAVETRAINER = 'react/common/trainers/SAVETRAINER',
    SAVETRAINER_PENDING = 'react/common/trainers/SAVETRAINER_PENDING',
    SAVETRAINER_FULFILLED = 'react/common/trainers/SAVETRAINER_FULFILLED',
    SAVETRAINER_REJECTED = 'react/common/trainers/SAVETRAINER_REJECTED',
    
    LOADTRAINER = 'react/common/trainers/LOADTRAINER',
    LOADTRAINER_PENDING = 'react/common/trainers/LOADTRAINER_PENDING',
    LOADTRAINER_FULFILLED = 'react/common/trainers/LOADTRAINER_FULFILLED',
    LOADTRAINER_REJECTED = 'react/common/trainers/LOADTRAINER_REJECTED',
    
    CREATENEWTRAINER = 'react/common/trainers/CREATENEWTRAINER',
    // USERCONNECTED = 'react/common/trainers/USERCONNECTED',
    // USERDISCONNECTED = 'react/common/trainers/USERDISCONNECTED',
    
    OTHER_ACTION = 'react/common/trainers/__any_other_action__',
}

export type Types = IBaseAction<Keys>;